import React, { useEffect, useState } from "react";
import Breadcrumbs from "../common/Breadcrumbs";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../router/all_routes";
import ListingSidebar from "./listingsidebar";
// import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
// import { CarInfo } from "../../core/data/interface/interface";
import AOS from "aos";
import "aos/dist/aos.css";
import { CarControllerApi, Configuration, PaginatedRequest, SortCriteria, SortCriteriaDirectionEnum } from "../../apiClient";
import { UUID } from "crypto";
// import { Image, TimePicker } from "antd";
import CarCard, { CardSize } from "../common/CarCard";
import { CarService } from "../../api/services/car.service";
import { Car, PaginatedResponseCar } from "../../apiClient";


const ListingGrid = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const routes = all_routes;
  const [selectedItems, setSelectedItems] = useState<UUID[]>([]);
  const [carData, setCarData] = useState<Car[] | undefined>([]);
  const [paginateRequest, setPaginateRequest] = useState<PaginatedRequest>({
    page: 0,
    pageSize: 6,
    filters: []
  });
  const [paginateResponse, setPaginateResponse] = useState<PaginatedResponseCar>();

  const handleSort = (criteria: string) => {
    // Sorting logic to be implemented on backend or via updated request interface
    console.log("Sort by", criteria);
  }

  const handleItemClick = (id: UUID) => {
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((item) => item !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
    // CarService.favorite(id); // TODO: Implement favorite
  };
  const setBookingDate = () => {}

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });

    const fetchCarData = async () => {
      try {
        const response = await CarService.getPaginated(paginateRequest.page || 0, paginateRequest.pageSize || 6, paginateRequest);
        setPaginateResponse(response);
        if (response && response.data) {
          setCarData(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch car data", error);
      }
    };

    fetchCarData();
  }, [paginateRequest]);

  const handlePageChange = (page: number) => {
    if (page >= 0 && page < (paginateResponse?.totalPages || 0)) {
        setPaginateRequest({
        ...paginateRequest,
        page: page
      });
    }
  };
  
  const renderPageNumbers = () => {
    if (!paginateResponse?.totalPages) return [];
    
    const currentPage = paginateRequest.page || 0;
    const totalPages = paginateResponse.totalPages;
    const pageNumbers = [];
    
    const maxPagesToShow = paginateRequest.pageSize || 6; // Using size as max pages to show logic for now, simplify later
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, startPage + 4);
    
    if (endPage - startPage < 4) {
      startPage = Math.max(0, endPage - 4);
    }
    
    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }
    
    return pageNumbers;
  };

  return (
    <div className="main-wrapper">
      <Breadcrumbs title="Showroom" subtitle="Toate Mașinile" />
      <div className="sortby-sec">
        <div className="container">
          <div className="sorting-div">
            <div className="row d-flex align-items-center">
              <div className="col-xl-4 col-lg-3 col-sm-12 col-12">
                <div className="count-search">
                    <p>
                    Afișează <span>{(paginateRequest.page || 0) * (paginateRequest.pageSize || 6) + 1}-{Math.min(((paginateRequest.page || 0) + 1) * (paginateRequest.pageSize || 6), paginateResponse?.totalCount || 0)}</span> din {paginateResponse?.totalCount} rezultate
                    </p>
                </div>
              </div>
              <div className="col-xl-8 col-lg-9 col-sm-12 col-12">
                <div className="product-filter-group">
                  <div className="sortbyset">
                    <span className="sortbytitle">Afișează : </span>
                    <div className="sorting-select select-one">
                      <Select
                      className="select w-100"
                      options={[{ value: 6, label: "6" }, { value: 10, label: "10" }, { value: 25, label: "25" }]}
                      placeholder="6"
                      isSearchable={false}
                      onChange={(option: any) => setPaginateRequest({ ...paginateRequest, pageSize: option?.value as number })}
                      styles={{ container: (base: any) => ({ ...base, width: '120px' }) }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="section car-listing">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-12 theiaStickySidebar">
              <div className="stickybar">
                <div className="stickysidebar">
                  <ListingSidebar filterOptions={paginateResponse?.filterOptions} paginateRequest={paginateRequest} setPaginateRequest={setPaginateRequest} />
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="row">
                {/* col */}
                {(carData || []).length === 0 ? (
                  <div className="col-12 text-center py-5">
                    <div style={{ fontSize: '48px', color: '#ccc', marginBottom: '20px' }}>
                      <i className="feather icon-inbox" />
                    </div>
                    <h4 style={{ color: '#666', marginBottom: '10px' }}>Nu există mașini disponibile</h4>
                    <p style={{ color: '#999' }}>Ne pare rău, momentan nu avem mașini în showroom.</p>
                  </div>
                ) : (
                  (carData || []).map((car, index) => (
                    <CarCard
                      key={car.id}
                      car={car}
                      selectedItems={selectedItems}
                      onHeartClick={handleItemClick}
                      size={CardSize.Small}
                    />
                  ))
                )}
              </div>
              {/*Pagination*/}
              <div className="blog-pagination">
                <nav>
                  <ul className="pagination page-item justify-content-center">
                    <li className={`previtem ${paginateRequest.page === 0 ? 'disabled' : ''}`}>
                      <Link 
                        className="page-link" 
                        to="#" 
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange((paginateRequest.page || 0) - 1);
                        }}
                        style={{ opacity: paginateRequest.page === 0 ? 0.5 : 1 }}
                      >
                        <i className="fa-solid fa-arrow-left"></i>
                        Prev
                      </Link>
                    </li>
                    <li className="justify-content-center pagination-center">
                      <div className="page-group">
                        <ul>
                          {renderPageNumbers().map(page => (
                            <li key={page} className="page-item">
                              <Link 
                                className={`page-link ${paginateRequest.page === page ? 'active' : ''}`}
                                to="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePageChange(page);
                                }}
                              >
                                {page + 1}
                                {paginateRequest.page === page && (
                                  <span className="visually-hidden">(current)</span>
                                )}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                    <li className={`nextlink ${(paginateRequest.page || 0) >= (paginateResponse?.totalPages || 0) - 1 ? 'disabled' : ''}`}>
                      <Link 
                        className="page-link" 
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePageChange((paginateRequest.page || 0) + 1);
                        }}
                        style={{ opacity: (paginateRequest.page || 0) >= (paginateResponse?.totalPages || 0) - 1 ? 0.5 : 1 }}
                      >
                        Next{" "}
                        <i className="fas fa-regular fa-arrow-right ms-2"></i>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              {/*/Pagination*/}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ListingGrid;
